/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getOrgAppDeviceHistory } from '../../../../../../../../store/reducers/organization/orgApplicationDevices/orgApplicationDevicesAction';

const OrgAppDeviceHistory = ({ selectedOrgAppDevice }) => {
    const [historyList, setHistoryList] = useState([]);
    const orgAppDeviceHistory = useSelector(state => state.orgApplicationDevices.orgAppDeviceHistory);
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getOrgAppDeviceHistory({ organizationApplicationDeviceID: selectedOrgAppDevice.organizationApplicationDeviceID }))

    }, [dispatch, selectedOrgAppDevice]);

    useEffect(() => {
        setHistoryList([]);
        if (orgAppDeviceHistory?.length > 0) {
            orgAppDeviceHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: '',
                        details: element.Record.organizationApplicationDeviceDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }]);
            });
        }
    }, [orgAppDeviceHistory]);
    return (
        <>
            <Typography variant="h3" align="center" color="success.light"> History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}

export default OrgAppDeviceHistory;